module.exports = __webpack_public_path__ + "static/aemo-logo-a7db7434c462b03af1506741b54532af.svg";